import { FunctionComponent } from 'react';
import ProductUsers from 'components/common/Product/ProductUsers/ProductUsers';
import { ProductName } from 'domain/product/enums/ProductName';

const Users: FunctionComponent = () => (
	<ProductUsers productName={ProductName.FlexInsight} />
);

export default Users;
